import React from "react";
import { IconButton } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Tooltip from "@material-ui/core/Tooltip";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

const HtmlTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: '#f6f6f6',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 320,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

export function TableDetailsButton(props: any) {
  const { t } = useTranslation();
  return (
    <HtmlTooltip
      title={
        <React.Fragment>
          <Typography color="inherit">
            {t('restaurant.list.gridLabels.details')}
          </Typography>
        </React.Fragment>
      }
    >
      <IconButton component={Link} to={`/restaurants/${props.id}/info`}>
        <VisibilityIcon />
      </IconButton>
    </HtmlTooltip>
  );
}
